import { Grid } from "@pushpress/shared-components";
import Skeleton from "react-loading-skeleton";

export default function PageLoadingState() {
  return (
    <>
      <Grid item marginX={10} marginY={10} xs={12}>
        <Skeleton height={200} width={700} />
      </Grid>
      <Grid container spacing={2} direction="column" marginX={10} marginY={5}>
        <Grid item>
          <Skeleton height={183} width={700} />
        </Grid>
        <Grid item paddingY={4}>
          <Skeleton height={183} width={700} />
        </Grid>
      </Grid>
    </>
  );
}
